<template>
    <model-modal
        :model-class="modelClass"
        modal-type="form"
        @opening="onOpening"
        @opened="onOpened"
        @resetted="onReset"
        ref="modal"
    >
        <template v-slot:default="slotProps">
            <form @submit.prevent="submit">
                <v-spa-input id="worksite-phase-trustup-io-task-form-title" ref="inputTitle" :form="form" input-name="title"></v-spa-input>
                <div class="mb-6 max-w-input">
                    <v-spa-label id="worksite-phase-task-form-modal-user" :label="$t('modals.worksite-phase-task-form-modal.labels.users')"></v-spa-label>
                    <select-user ref="selectUser" :initial-value="slotProps.model ? slotProps.model.users_id : []" :as-field="true" :multiple="true" @updated="updateUsers"></select-user>
                </div>
                <v-spa-date-picker id="worksite-phase-task-form-modal-due_date" :popover="{ visibility: 'click' }" :form="form" input-name="due_date"></v-spa-date-picker>
                <v-spa-element v-if="! model" id="worksite-phase-task-form-modal-phase" :form="form" input-name="model" :label="$t('modals.worksite-phase-task-form-modal.labels.phase')">
                    <select :class="$spa.css.form.select" v-model="form.model">
                        <option :value="phase" :key="phase.uuid" v-for="phase in phases">
                            {{ phase.title }}
                        </option>
                    </select>
                </v-spa-element>
                <v-spa-loading-button :loading="form.isLoading()">
                    {{ slotProps.model ? $t('modals.worksite-phase-task-form-modal.edit_button') : $t('modals.worksite-phase-task-form-modal.create_button') }}
                </v-spa-loading-button>
            </form>
        </template>
    </model-modal>
</template>

<script>
    import ModelModal from '@spa/apps/trustup-pro-base-js/components/Model/Modal';
    import WorksitePhaseTrustUpIOTask from '@spa/apps/trustup-pro-worksite-js/models/WorksitePhaseTrustUpIOTask';
    import SelectUser from "@spa/apps/trustup-pro-base-js/components/_Partials/Selects/User";
    import Form from '@spa/classes/Form';

    export default {
        components: {
            ModelModal,
            SelectUser,
        },

        data() {
            return {
                modelClass: WorksitePhaseTrustUpIOTask,
                phases: null,
                form: new Form({
                    title: '',
                    users: [],
                    model: null,
                    due_date: null
                })
            }
        },

        computed: {
            model()
            {
                return this.$refs.modal.model;
            },
        },
        
        methods: {
            onOpening(data)
            {
                console.log('onOpening', data);
                if ( data.worksitePhases ) {
                    this.phases = data.worksitePhases;
                    this.form.model = data.worksitePhases[0];
                }
                
                if ( data.currentPhase ) {
                    this.form.model = data.currentPhase;
                }

                if ( data.form ) {
                    // this.form.title = data.form.title;
                    this.form.due_date = data.form.due_date;
                    this.form.users = data.form.users;
                }

                if ( this.model ) {
                    this.form.title = this.model.title;
                    this.form.due_date = this.model.due_date;
                    this.form.users = this.model.users;
                    console.log('test2');
                    this.form.model = this.phases.find(p => p.uuid === this.model.model_id);
                }
            },

            async onOpened()
            {
                await this.$nextTick();
                await this.$nextTick();
                this.$refs.inputTitle.$refs.input.focus();
            },

            onReset()
            {
                this.form.reset();
                this.form.stop();
                this.phases = null;
            },

            updateUsers(users)
            {
                this.form.users = this.$refs.selectUser.usersModel;
            },

            async submit()
            {
                await this.model
                    ? this.updateTask()
                    : this.storeTask();
            },

            async storeTask()
            {
                if ( this.form.isLoading() ) {
                    return;
                }
                
                this.form.load();
                
                await window.TrustUpBase.endpoints.trustupIOTask.store({
                    ...{
                        title: this.form.title,
                        due_date: this.form.due_date,
                        users: this.form.users,
                        done_at: null,
                        is_having_due_date_time: false,
                        professional_authorization_key: this.$store.state.account.authorization_key,
                        account_uuid: this.$store.state.account.uuid
                    },
                    ...this.form.model.trustup_io.model
                });

                this.$refs.modal.close();
            },

            async updateTask()
            {
                if ( this.form.isLoading() ) {
                    return;
                }
                
                this.form.load();

                this.model.title = this.form.title;
                this.model.users = this.form.users;
                this.model.due_date = this.form.due_date; 
                
                await this.model.getEndpoint().update({uuid: this.model.uuid, data: this.model.data()});
                
                this.$refs.modal.close();
            }
        }
    }
</script>